import { Component, Input } from '@angular/core';
import { FeedbackService } from 'src/services/feedback.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css'],
  standalone: false,
})
export class FeedbackComponent {

  mostrarTextBox = false;
  feedbackEnviado = false;
  comentario = '';
  feedbackPositivo: boolean | null = null;
  @Input() idArticle: number;

  constructor(
    private feedbackService: FeedbackService,
  ) {}

  abrirTextBox() {
    this.mostrarTextBox = true;
  }

  fecharTextBox() {
    this.mostrarTextBox = false;
  }

  enviarComentario(positivo: boolean, comentario: string) {
  
    const tamanho = comentario.trim().length;
    if (!positivo && (tamanho > 0 && tamanho < 10 || tamanho > 1000)) {
      return;
    }

    let thumbs = "thumbs_up";
    this.feedbackPositivo = true;
    if (!positivo) {
      thumbs = "thumbs_down";
      this.feedbackPositivo = false;
    }

    this.feedbackService.saveFeedback(this.idArticle, thumbs, comentario).subscribe();
    this.feedbackEnviado = true;

    // Reseta
    this.comentario = '';
    this.mostrarTextBox = false;
  }
}
